import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode, useState } from 'react';

type PreviewSectionProps = {
    title: string;
    children: ReactNode | ReactNode[];
    defaultCollapsed?: boolean;
};

function PreviewSection({ title, children, defaultCollapsed = true }: PreviewSectionProps): JSX.Element {
    const [isOpen, setIsOpen] = useState(!defaultCollapsed);

    return (
        <div>
            <div className="flex items-center gap-2">
                <button onClick={(): void => setIsOpen(!isOpen)}>
                    <ChevronDownIcon className={`transition-all text-gray-500 h-5 w-5 ${isOpen ? '' : 'rotate-180'}`} />
                </button>
                <p className="font-bold text-sm text-gray-800">{title}</p>
            </div>
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        initial={{
                            height: 0,
                            opacity: 0,
                        }}
                        animate={{
                            height: 'auto',
                            opacity: 1,
                        }}
                        exit={{
                            height: 0,
                            opacity: 0,
                        }}
                        transition={{ duration: 0.2 }}
                    >
                        <div>{children}</div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default PreviewSection;
